import { Flex, IconButton } from '@lego/klik-ui';
import { CheckTick, ControlClose, Edit } from '@lego/klik-ui/icons';
import type { MouseEventHandler } from 'react';

type EditButtonsProps = {
  isEditing: boolean;
  isSaving: boolean;
  onEdit?: MouseEventHandler<HTMLButtonElement>;
  onSave: MouseEventHandler<HTMLButtonElement>;
  onCancel: MouseEventHandler<HTMLButtonElement>;
  editLabel?: string;
  saveDisabled?: boolean;
  editDisabled?: boolean;
};

export const EditButtons = ({
  isEditing,
  isSaving,
  onEdit,
  onSave,
  onCancel,
  saveDisabled,
  editDisabled,
  editLabel = 'Edit',
}: EditButtonsProps) => {
  if (isEditing) {
    return (
      <Flex gap="1">
        <IconButton
          aria-label="Save edit"
          icon={<CheckTick />}
          isDisabled={isSaving || saveDisabled}
          isLoading={isSaving}
          onClick={onSave}
          size="sm"
        />
        <IconButton
          aria-label="Cancel edit"
          icon={<ControlClose />}
          isDisabled={isSaving}
          onClick={onCancel}
          size="sm"
          variant="outline"
        />
      </Flex>
    );
  }
  return (
    <IconButton
      aria-label={editLabel || 'Edit'}
      color="LinkText"
      icon={<Edit />}
      isDisabled={editDisabled}
      onClick={onEdit}
      paddingBottom="2"
      size="xs"
      variant="solid"
    />
  );
};
